export const HAS = 'has';
export const IS = 'is';

export const HAS_YES = 'есть';
export const HAS_NO = 'нет';
export const IS_YES = 'да';
export const IS_NO = 'нет';
export const UNSPECIFIED = 'не указано';
export const NOT_FOUND = 'нет данных';
export const NOT_IMPORTANT = 'неважно';

export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const ERROR = '_ERROR';

export const SHOW = '_SHOW';
export const HIDE = '_HIDE';

export const CREATE = '_CREATE';
export const UPDATE = '_UPDATE';
export const REMOVE = '_REMOVE';
export const CHANGED = '_CHANGED';

export const FORM_SHOW = '_FORM_SHOW';
export const FORM_HIDE = '_FORM_HIDE';
export const MODAL_SHOW = '_MODAL_SHOW';
export const MODAL_HIDE = '_MODAL_HIDE';

export const SALE = 'sale';
export const RENT = 'rent';
export const RENTDAILY = 'rentDaily';
export const APARTMENTS = 'apartments';
export const LANDS = 'lands';
export const COMMERCIALS = 'commercials';
export const GARAGES = 'garages';

export const TREND_UP = 'up';
export const TREND_DOWN = 'down';

export const LOCATION_HOUSE = 'house';
export const LOCATION_STREET = 'street';
export const LOCATION_LOCALITY = 'locality';
export const LOCATION_CUSTOM = 'custom';

export const SAVED_FILTER_VERSION = 383;

/**
 * Падежи
 * @type {{SINGULAR: string, PLURAL: string, NOMINATIVE: string, GENITIVE: string, DATIVE: string, ACCUSATIVE: string, ABLATIVE: string, PREPOSITIONAL: string}}
 */
export const CASES = {
  SINGULAR: 'singular',
  PLURAL: 'plural',

  NOMINATIVE: 'nominative',
  GENITIVE: 'genitive',
  DATIVE: 'dative',
  ACCUSATIVE: 'accusative',
  ABLATIVE: 'ablative',
  PREPOSITIONAL: 'prepositional'
};

export const COMPLEX = {
  residential: 'residentialComplexes',
  cottage: 'villages'
};

export const MAPS_VENDORS = {
  dgis: 'maps_2gis',
  yandex: 'maps_yandex',
  google: 'maps_google'
};

export const TILE_VENDORS = {
  dgis: {
    url: 'https://rtile{s}.maps.2gis.com/tiles?v=1.3&x={x}&y={y}&z={z}',
    attribution: '<a href="https://2gis.ru">2GIS</a>'
  },
  osm: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }
};

export const PANORAMAS_VENDORS = {
  yandex: 'panoramas_yandex',
  google: 'panoramas_google'
};

export const VIEW_MODE = {
  grid: 'grid',
  map: 'map',
  paper: 'paper'
};

export const MAP_DRAW_MODE = {
  NONE: 0,
  CREATE: 1,
  EDIT: 2
};

export const COLUMN_TYPES = {
  realtyType: 1,
  description: 2,
  descriptionAndType: 3,
  price: 4,
  priceAndPay: 5,
  priceAndPricePerMeter: 6,
  pricePerMeter: 7,
  priceTotal: 8,
  area: 9,
  building: 10,
  contacts: 11,
  moreProperty: 12,
  date: 13,
  land: 14,
  address: 15,
  photos: 16,
  material: 17,
  seller: 18,
  floor: 19,
  buildingSize: 20,
  dealCondition: 21
};

export const APP_NAMES = {
  search: 'search',
  favorites: 'favorites'
};

export const ADFOX = {
  topWideScreenHome: 'top_widescreen_home',
  topWideScreenSearch: 'top_widescreen_search',
  cardSidebar_1: 'card_sidebar_1',
  cardSidebar_2: 'card_sidebar_2',
  cardSidebar_3: 'card_sidebar_3',

  cardRestComplex_1: 'card_rest_complex_1',

  favoritesPage_1: 'favorites_page_1',
  favoritesPage_2: 'favorites_page_2',

  listingGrid_1: 'listing_grid_1',
  listingGrid_2: 'listing_grid_2',
  listingGrid_3: 'listing_grid_3',
  listingGrid_4: 'listing_grid_4',
  listingHeader: 'listing_header',
  listingFooter: 'listing_footer',

  homeSlider_1: 'home_slider_1',
  homeSlider_2: 'home_slider_2',
  homeSplitter_1: 'home_splitter_1',
  homeSplitter_2: 'home_splitter_2',
  homeSplitter_3: 'home_splitter_3',
  homeAliasMenu: 'home_alias_menu',
  homeBuilder: 'home_builder',
  homeFooter: 'home_footer'
};

export const DFP = {
  listingHeader: '1',   // Место в шапке
  listingGrid_1: '2',   // Баннер в списке, первый сверху
  listingGrid_2: '2',   // Баннер в списке, второй сверху
  listingGrid_3: '2',   // Баннер в списке, третий сверху
  listingGrid_4: '2',   // Баннер в списке, четвертый сверху
  listingFooter: '3',   // Баннер под выдачей (программатик)
  cardSidebar_1: '4',   // Вертикальный в карточке, первый сверху
  cardSidebar_2: '5',   // Вертикальный в карточке, второй сверху
  homeBuilder: '6'      // Тизер (спецпредложение застройщика)
};

export const REALTY_TYPES = {
  land: 35,               // земельный участок
  dacha: 36,              // дача
  flat0: 44,              // квартира на первом этаже
  flat1: 1,
  flat2: 2,
  flat3: 3,
  flat4: 4,
  flat5: 5,
  flatOneFloor: 44,       // квартира на первом этаже
  flatParts: 107,         // доля в квартире
  room: 0,                // комната
  house: 101,             // дом
  cottage: 103,           // коттедж
  townHouse: 104,         // таунхаус
  hostel: 106,            // хостел
  garageMetal: 311,       // металлический гараж
  garageConcrete: 312     // железобетонный гараж
};

export const PAGE_TYPES = {
  TYPE_LISTING: 'listing',
  TYPE_CARD: 'card',
  TYPE_POSITION: 'position'
};

export const DISTRICTS = {
  center: 'center',
  suburb: 'suburb',
  kirovskij: 52401364,
  leninskij: 52401372,
  oktyabrskij: 52401376,
  sovetskij: 52401380,
  centralnyj: 52401382
};



// WEBPACK FOOTER //
// ./src/consts.js